<template>
  <div class="comment__container p-6">
    <div class="pb-4">
      <div class="flex justify-between items-center">
        <div class="flex items-center">
          <zt-icon name="calendar" />
          <span class="day pl-2">{{ comment.fecha }}</span>
        </div>
        <div>
          <div class="flex items-center">
            <zt-avatar :text="comment.usuario" size="small" />
            <p class="pl-2">{{ comment.usuario }}</p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <p class="content">{{ comment.observacion }}</p>
    </div>
    <div v-if="isActionAllowed(26)" class="pt-4 flex justify-end">
      <zt-button
        :class="{ 'button-loading': isLoading }"
        :loader="isLoading"
        :disabled="isLoading"
        @click="activeDeleteDialog = true"
        icon="trash-outline"
        outlined
      >
        {{ $t('message.documentDetail.comments.deleteComment') }}
      </zt-button>
    </div>
    <zt-modal
      v-if="isActionAllowed(26)"
      class="rounded font-normal"
      :title="$t('message.documentDetail.comments.modalDelete.title')"
      @close="closeDialog"
      max-width="600px"
      :active="activeDeleteDialog"
      :z-index="1001"
    >
      <template>
        <div class="flex px-10 py-12">
          <div
            class="flex flex-none items-center w-24 h-24 justify-center mr-16"
          >
            <zt-icon
              name="exclamation-circle-outline"
              class="text-zt-warning"
              :style="{ fontSize: '6rem' }"
            />
          </div>
          <div>
            <p class="text-zt-xl mb-4 text-zt-dark-500">
              <span>{{ $t('message.documentDetail.comments.modalDelete.body') }}</span>
            </p>
            <p class="mb-4 text-zt-dark-500">
              <span>
                {{ $t('message.documentDetail.comments.modalDelete.legend') }}
              </span>
            </p>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <div
          class="zt-modal-footer rounded-b flex justify-end items-center p-4"
        >
          <zt-button
            text
            color="dark-300"
            class="button-cancel mr-4"
            @click="closeDialog"
            data-vs-button="closeDialog"
          >
            {{ $t('message.documentDetail.comments.modalDelete.buttonCancel') }}
          </zt-button>
          <zt-button
            class="w-25"
            @click="confirm"
            data-vs-button="confirmChanges"
          >
            {{ $t('message.documentDetail.comments.modalDelete.buttonOk') }}
          </zt-button>
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CommentItem',
  inject: ['deleteComment'],
  props: ['comment'],
  data() {
    return {
      isLoading: false,
      activeDeleteDialog: false
    }
  },
  computed: {
    ...mapGetters(['isActionAllowed'])
  },
  methods: {
    closeDialog() {
      this.activeDeleteDialog = false
    },
    async confirm() {
      this.isLoading = true
      this.activeDeleteDialog = false
      await this.deleteComment(this.comment.idobservacion_doc)
      this.isLoading = false
    }
  }
}
</script>

<style>
.content {
  color: #2d2d2d;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.day {
  color: #575757;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
}

.comment__container {
  border-radius: 8px;
  border: 1px solid #ccc;
}

.zt-modal-footer {
  background-color: #eeeeee;
}

::v-deep .zt-modal .zt-modal {
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
}
::v-deep .zt-modal .zt-modal.rounded {
  border-radius: 0.375rem !important;
}
.zt-modal button.button-cancel {
  color: #707070 !important;
  background-color: transparent !important;
}

.button-loading {
  background: #CAC6E3 !important;
  color: #4F41A3 !important;
  opacity: 0.5;
}
</style>
